import { Outlet, redirect } from "@vixi/router";
import Sidebar from "../../components/layout/Sidebar/Sidebar";
import { Suspense } from "react";
import { RouteOptionsById, router, RouterIds } from "@vixi/router";
import { AppShell, ConfirmationDialog, Header, LoadingScreen, Toaster } from "@vixi/ui";
import { getAuthState } from "@vixi/api";
import { InProgressCoursesSection } from "@/components/dashboard/InProgressCoursesSection";

const routeId = "/_app" satisfies RouterIds;
const _Route = router.routesById["/_app"];

export const AppRouteOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
  beforeLoad: async () => {
    if (!getAuthState().isLoggedIn()) {
      throw redirect({
        to: "/login",
      });
    }
  },
};

function RouteComponent() {
  return (
    <>
      <AppShell sidebar={<Sidebar />} header={<Header />}>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </AppShell>

      {/* Fixed Progress Card - Shows in all pages */}
      <InProgressCoursesSection />

      <ConfirmationDialog />
      <Toaster />
    </>
  );
}
